import { useNavigate } from "react-router-dom";
import { useLiveQuizSocket } from "../../contexts/LiveQuizSocketContext";
import { useTranslation } from "../../hooks/useTranslation";

export default function LiveQuizInvitePopup() {
    const { socket, invite, setInvite, setActiveRoom } = useLiveQuizSocket();
    const navigate = useNavigate();
    const { t } = useTranslation();

    if (!invite) return null;

    const handleJoin = () => {
        socket.emit("join_room", { roomCode: invite.roomCode });
        setActiveRoom(invite);
        setInvite(null);
        navigate(`/livequiz/game/${invite.roomCode}`);
    };

    return (
        <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.6)", zIndex: 9999 }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content border-0 shadow-lg" style={{ backgroundColor: "var(--bg-card)" }}>
                    <div className="modal-header bg-primary text-white border-0">
                        <h5 className="modal-title fw-bold">🎮 {t.liveQuiz.inviteTitle}</h5>
                    </div>
                    <div className="modal-body text-center py-4">
                        <p className="mb-1" style={{ color: "var(--text-muted)" }}>
                            {t.liveQuiz.inviteTeacher} <strong style={{ color: "var(--text-primary)" }}>{invite.teacherName}</strong> {t.liveQuiz.inviteStarts}
                        </p>
                        <h4 className="fw-bold mb-0" style={{ color: "var(--text-primary)" }}>{invite.quizTitle}</h4>
                    </div>
                    <div className="modal-footer border-0 justify-content-center gap-2">
                        <button className="btn btn-outline-secondary" onClick={() => setInvite(null)}>
                            {t.liveQuiz.decline}
                        </button>
                        <button className="btn btn-primary px-4" onClick={handleJoin}>
                            {t.liveQuiz.joinNow}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
